<ppl-accordion [title]="'Application Summary'" [isOpen]="true" *authorize="[pageId, tabId, 'Summary', 'section']">
    <div class="tile-grid">

        @if (isDataLoaded) {
        @if(isParticipantFlow || (associationMap && associationMap['IR'])) {
        <div class="tile">
            <p class="summary-heading">Welcome Letter</p>
            <div class="button-container no-padding no-margin">
                <a class="view-welcome-letter btn btn-info" (click)="viewWelcomeLetter()">View</a>
                <a class="download-welcome-letter btn btn-primary" (click)="handleDownload()">Download</a>
            </div>
        </div>
        }

        @if (isPA && isPAOfferLetterDataLoaded) {
        <div class="tile">
            <p class="summary-heading">Offer Letters</p>
            <p class="count completed-count">{{noOfPWCompleted}} out of {{totalOfferLetters}} Completed</p>
        </div>
        }

        @for (appInfo of applicationInfoItems; track appInfo; let idx = $index ) {
        <div class="tile">
            <p class="summary-heading">{{appInfo.summaryItemDisplayName}}</p>
            <p class="count">{{appInfo.summaryItemValue}}</p>
        </div>
        }


        @for (summaryItem of summaryItems; track summaryItem; let idx = $index ) {
        <div class="tile">
            <p class="summary-heading">{{summaryItem.summaryItemDisplayName}}</p>
            <p class="count">{{summaryItem.summaryItemValue}}</p>
        </div>
        }

        @for (auth of authorizationItems; track auth; let idx = $index ) {
        <div class="tile">
            <p class="summary-heading">{{auth.summaryItemDisplayName}}</p>
            <p class="count">{{auth.summaryItemValue}}</p>
        </div>
        }

        @if(isPA) {
        <div class="tile">
            <p class="summary-heading">Additional Demographics</p>
            <div class="button-container no-padding no-margin">
                @if (!this.filledInfo?.isWotcCertified) {
                <a class="download-welcome-letter btn btn-primary" (click)="openAdditionalDemographicsPopup()">Update
                    Now</a>
                } @else {
                <p class="count completed-count">Completed</p>
                }
            </div>
        </div>
        }

        @if (isProviderFlow) {
        <ppl-lead-detail-summary-training-tile [programCode]="program.program_code"
            [selectedProviderId]="selectedLead" />
        }
        }
    </div>


     @if (isPA) {
    <div class="fs-5 fw-bold fst-italic pt-2 pb-2">
        Attention Personal Assistant:
        <ol class="mt-2">
            <li class="mb-2 nostyle">
                Before PPL can verify your employment eligibility (E-Verify), the following is
                needed:
                <ul>
                    <li>Sign your Offer Letter. Please go to the Forms tab, then <a class="highlight"
                            (click)="navigateToForms()">Offer
                            Letters</a>, and click on the
                        View button.</li>
                    <li>Complete your I-9 under the <a class="highlight" (click)="navigateToForms()">Forms
                            tab</a>.</li>
                    <li>Upload your I-9 Documentation under Required Documents tab. Please click at the <a
                            href="https://www.uscis.gov/i-9-central/form-i-9-acceptable-documents"
                            target="_blank">link</a> to look at supporting docs. </li>
                </ul>
            </li>
        </ol>
    </div>
    }
</ppl-accordion>



<div class="filter-panel">

    <ng-template #pdfDialog let-cancel="cancel">
        <div class="" *ngIf="pdfConfig && pdfFile">
            <ppl-editpdf (fieldsUpdated)="fieldsUpdated($event)" [readonly]="true" [pdfConfig]="pdfConfig"
                [signature]="" [pdfBlob]="pdfBlob" [pdfFile]="pdfFile" [signatureId]=""
                [isParticipantFlow]="isParticipantFlow" [selectedParticipantId]="selectedLead"
                [isSelf]="true"></ppl-editpdf>
        </div>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #additionalDemographicsDialog let-cancel="cancel">
        <ppl-additional-demographics [id]="selectedLead" (onUpdate)="handlePopUpClose()"></ppl-additional-demographics>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #alertAdditionalDemographicsDialog let-cancel="cancel">
        <p class="p-1">Please complete the additional demographic questions, by clicking on Update Now button on
            Additional Demographics tile.</p>
    </ng-template>
</div>